import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'obfuscateEmail',
})
export class ObfuscateEmailPipe implements PipeTransform {
  transform(email: string | null | undefined): string {
    if (!email) {
      return '';
    }

    const [local, domain] = email.split('@');
    if (!domain) {
      return email; // not a valid email, return as-is
    }

    if (local.length <= 2) {
      return local[0] + '*'.repeat(Math.max(local.length - 1, 0)) + '@' + domain;
    }

    const first = local[0];
    const last = local[local.length - 1];
    const stars = '*'.repeat(5);

    return `${first}${stars}${last}@${domain}`;
  }
}
